import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip'
import Box from '@mui/material/Box'

export const Tooltip = ({ children, ...props }: TooltipProps): React.ReactElement => {
  return (
    <MuiTooltip {...props} arrow followCursor>
      <Box>{children}</Box>
    </MuiTooltip>
  )
}
